import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '@environment';
import { GlobalsService, isAssigned } from '@data';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    constructor(
        @Inject(DOCUMENT) private readonly _document: Document,
        private readonly _globalsSrv: GlobalsService,
    ) {
        this.switchTheme(this.isDarkMode);
    }

    get isDarkMode() {
        const val = this._globalsSrv.getValue('isDarkMode');
        let isDarkMode = environment.isDarkMode;

        if (isAssigned(val)) {
            isDarkMode = val?.toLowerCase() === 'true';
        }

        return isDarkMode;
    }

    switchTheme(isDarkMode: boolean) {
        this._globalsSrv.setValue('isDarkMode', isDarkMode ? 'true' : 'false');

        const element = this._document.documentElement;
        if (isDarkMode) {
            element.classList.add('dark-mode');
        } else {
            element.classList.remove('dark-mode');
        }
    }

    toggleTheme() {
        this.switchTheme(!this.isDarkMode);
    }
}
